import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs/Observable";
import { Subject } from "rxjs/Subject";
import "rxjs/add/operator/map";
import { Customer } from "../../interface/customer";

@Injectable()
export class CustomerService {
  customerAction = new Subject();
  constructor(private httpClient: HttpClient) {}

  list(): Observable<Customer[]> {
    return this.httpClient.get<Customer[]>("customer");
  }

  create(form): Observable<any> {
    let body = form;
    return this.httpClient.post("customer", body);
  }

  update(form): Observable<any> {
    let body: any = {};
    if (form.customerId) {
      body.customerId = form.customerId;
    }
    if (form.name) {
      body.name = form.name;
    }
    if (form.mobile) {
      body.mobile = form.mobile;
    }
    if (form.email) {
      body.email = form.email;
    }
    if (form.address) {
      body.address = form.address;
    }
    if (form.roleId) {
      body.roleId = form.roleId;
    }
    if ([0,1].includes(form.isActive)) {
      body.isActive = form.isActive;
    }

    return this.httpClient.patch("customer", body);
  }

  delete(customerId) {
    return this.httpClient.delete("customer/" + customerId);
  }

  subscription() {
    return this.httpClient.post("customer/subscription", []);
  }

  getAction(): Observable<any> {
    return this.customerAction.asObservable();
  }

  sendAction(action, data) {
    this.customerAction.next({ action: action, data: data });
  }
}



// WEBPACK FOOTER //
// D:/Xpand-Dubai/xpand_retail_int/Customers/app/src/app/shared/services/customer/customer.service.ts